'use client';

import { AuthLayoutWrapper } from '@/components/auth/authLayout';
import '@/styles/globals.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { purgeSession } from '@/utility/auth/purgeSession';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated,
  );
  const dispatch = useDispatch();

  const router = useRouter();

  useEffect(() => {
    const accessToken = localStorage.getItem('ACCESS_TOKEN');

    // Only purge when persisted auth disagrees with stored tokens.
    if (!accessToken && isAuthenticated) {
      void purgeSession({ dispatch });
      return;
    }

    if (isAuthenticated && accessToken) {
      router.replace('/');
    }
  }, [isAuthenticated, router, dispatch]);

  if (isAuthenticated) {
    return null; // or you could return a loading spinner or something else
  }

  return <AuthLayoutWrapper>{children}</AuthLayoutWrapper>;
}
